/*
  Flowkeeper - Pomodoro timer for power users and teams
  Copyright (c) 2023 Constantine Kulak, Geoffrey Espagne

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation; either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

import {
    Alert,
    AlertActionCloseButton
} from '@patternfly/react-core';

type GenericAlertProps = {
    variant: 'warning' | 'danger' | undefined,
    message: string,
    truncateTitle: number
}

GenericAlert.defaultProps = {
    variant: 'warning',
    message: 'Unknown alert.',
    truncateTitle: 1
}

export function GenericAlert(props: GenericAlertProps) {
    return (
        <Alert
            variant={props.variant}
            truncateTitle={props.truncateTitle}
            title={props.message}
            isInline
            actionClose={<AlertActionCloseButton onClose={() => {}} />}
        />
    );
}


